module.exports = __webpack_public_path__ + "static/media/UsefulArticlesBg.95c59323.png";